<template>
  <span>
    <span v-if="status == 'Open'" class="badge bg-secondary"
      >New / In Triage</span
    >
    <span v-if="status == 'In Progress'" class="badge bg-success"
      >In Progress</span
    >
    <span v-if="status == 'Resolved'" class="badge bg-success"
      >Resolved</span
    >
  </span>
</template>

<script>
export default {
  props: ['status'],
}
</script>
